import { Typography, Link, useDialog, FlexGrid } from "@albo-ui/core";
import { ModalCompanyRecordDialog } from "./ModalCompanyRecord";


export const ItemCompanyRecord = ({ data, name, changeAlert, changeLoader }) => {
    const dialogProps = useDialog();

    return <>
        <FlexGrid container>
            <Typography variant="paragraph" color="lightNeutral" style={{ width: "45%", paddingRight: 25 }}>
                {name}
            </Typography>
            <Link underlined style={{ display: "flex", alignItems: "center", width: "55%" }} onClick={dialogProps.openDialog} >
                {name}
            </Link>
        </FlexGrid>
        <ModalCompanyRecordDialog
            {...dialogProps}
            open={dialogProps.open}
            onClose={dialogProps.onClose}
            uuid={data} 
            changeAlert={changeAlert}
            changeLoader={changeLoader}
        />
    </>
}
